import React, { useCallback, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useDevice } from '../../contexts/DeviceContext';

export default function SearchResults({
  navbarRef,
  searchResults,
  searchVisible,
  setSearchVisible,
  searchValue,
  setSearchValue,
}) {
  const { isMobile } = useDevice();
  const searchResultsRef = useRef(null);
  
  useEffect(() => {
    if (searchResultsRef.current && navbarRef.current) {
      searchResultsRef.current.style.top = `${navbarRef.current.offsetHeight}px`;
    }
  }, [navbarRef]);

  const clickSearchResult = () => {
    setSearchValue('');
    setSearchVisible(false);
  };

  const handleDocumentClick = useCallback(
    (event) => {
      if (searchVisible && (!navbarRef.current.contains(event.target) && !searchResultsRef.current.contains(event.target))) {
        setSearchVisible(false);
      }
    }, [searchVisible, setSearchVisible, navbarRef]
  );

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [handleDocumentClick]);

  return (
    <SEARCH_RESULTS
      ref={searchResultsRef}
      $searchVisible={
      searchVisible && searchValue && (
        searchResults.issues?.length > 0 ||
        searchResults.authors?.length > 0 ||
        searchResults.pieces?.length > 0
      )
      }
    >
      {searchResults.issues?.map((result, index) => (
        <Link
          key={index}
          className='link'
          to={`/issues/${result.id}`}
          onClick={clickSearchResult}
          >
            <li>
                {result.title}
            </li>
        </Link>
      ))}

      {searchResults.authors?.map((result, index) => (
        <Link
          key={index + searchResults.issues.length}
          className='link'
          to={`/authors/${result.slug}`}
          onClick={clickSearchResult}
        >
            <li>
                {result.full_name}
            </li>
        </Link>
      ))}

      {searchResults.pieces?.map((result, index) => (
        <Link
          key={index + searchResults.issues.length + searchResults.authors.length}
          className='link'
          to={`/pieces/${result.id}`}
          onClick={clickSearchResult}
        >
          <li>
              {result.title}
          </li>
        </Link>
      ))}
    </SEARCH_RESULTS>
  )
}

const SEARCH_RESULTS = styled.ul`
  position: absolute;

  display: ${props => props.$searchVisible ? 'flex' : 'none'};
  flex-direction: column;

  padding: 1.25rem 0.5rem;
  margin: 0;
  width: 100%;

  list-style: none;

  background-color: white;
  border-bottom: 1px solid black;
  z-index: 1;
  box-shadow: 0px 15px 10px -15px rgba(0, 0, 0, 0.3);

  & li {
    padding: 0.5rem 0.5rem;
    width: 100%;
    border-radius: 0.25rem;
  }

  & li:hover {
    background-color: #f2f2f2;
  }

  & .link {
    width: 100%;
    padding: 0;
    font-size: 1rem;
    font-weight: 700;
    font-family: var(--primary-font);
    color: black;
    text-decoration: none;
  }
`;